const OfferNumber = ({offerNumber}: IOfferNumberProps) => {
  return (
    <div className="flex justify-between mt-7">
      <div className="flex">
        <span className="icon-auction-card text-primary ml-1 mt-1"></span>
        <p className=" text-gray-6">تعداد پیشنهادات:</p>
      </div>
      <p className=" text-gray-6">{offerNumber} تا</p>
    </div>
  );
};

export default OfferNumber;
